import { connect } from 'react-redux'
import {
  compose,
  branch,
  renderNothing,
  withProps,
  lifecycle,
  withStateHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import * as ConversationActions from 'app/modules/conversation/actions'
import withGlobalAutoCloseConfiguration from './withGlobalAutoCloseConfiguration'
import Component from './component'
import * as delayTimeUtils from 'components/DelayTime/utils'

const MINUTE = 60 * 1000
const DAYS_IN_WEEK = 7
const WEEK = MINUTE * 60 * 24 * DAYS_IN_WEEK


const mapDispatchToProps = dispatch => bindActionCreators({
  updateGlobalAutoCloseConfiguration: ConversationActions.updateGlobalAutoCloseConfiguration,
}, dispatch)

export default compose(
  withGlobalAutoCloseConfiguration,
  branch(props => !props.isGlobalAutoCloseConfigurationLoaded, renderNothing),
  connect(null, mapDispatchToProps),
  withStateHandlers(
    ({ globalAutoCloseConfiguration }) => {
      const timeoutInMilliseconds = _.get(globalAutoCloseConfiguration, 'timeout', 10 * MINUTE)
      const unit = delayTimeUtils.defaultUnit(timeoutInMilliseconds)
      const humanizedTimeoutValue = parseInt(delayTimeUtils.toHumanizedValue(timeoutInMilliseconds, unit))

      return {
        isEnabled: _.get(globalAutoCloseConfiguration, 'isEnabled', false),
        timeoutUnit: unit,
        savedUnit: unit,
        timeoutValue: humanizedTimeoutValue,
        savedTimeout: humanizedTimeoutValue,
        filters: _.get(globalAutoCloseConfiguration, ['filters'], {})
      }
    },
    {
      setIsEnabled: ({ savedTimeout, savedUnit, filters }, { updateGlobalAutoCloseConfiguration }) => isEnabled => {
        updateGlobalAutoCloseConfiguration({
          isEnabled,
          timeout: delayTimeUtils.toMilliseconds(savedTimeout, savedUnit),
          filters: filters
        })

        return { isEnabled } // Optimistic Update
      },
      setFilters: ({ isEnabled, filters, savedTimeout, savedUnit }, { updateGlobalAutoCloseConfiguration }) => newFilters => {
        const updatedFilters = {}
        _.merge(updatedFilters, filters, newFilters)

        updateGlobalAutoCloseConfiguration({
          isEnabled,
          timeout: delayTimeUtils.toMilliseconds(savedTimeout, savedUnit),
          filters: updatedFilters
        })

        return { filters: updatedFilters }
      },
      setTimeoutUnit: () => timeoutUnit => ({ timeoutUnit }),
      setTimeoutValue: () => timeoutValue => ({ timeoutValue: parseInt(timeoutValue) }),
      discardUnsavedChanged: ({ savedTimeout, savedUnit }) => () => ({ timeoutValue: savedTimeout, timeoutUnit: savedUnit }),
      saveChanges: ({ isEnabled, timeoutValue, timeoutUnit, filters }, { updateGlobalAutoCloseConfiguration }) => () => {
        updateGlobalAutoCloseConfiguration({
          isEnabled,
          timeout: delayTimeUtils.toMilliseconds(timeoutValue, timeoutUnit),
          filters: filters
        })
      },
      handleGlobalAutoCloseConfigurationChange: ({ timeoutUnit }, { globalAutoCloseConfiguration, onChangeSuccess }) => () => {
        const timeoutInMilliseconds = _.get(globalAutoCloseConfiguration, 'timeout')
        const humanizedTimeoutValue = parseInt(delayTimeUtils.toHumanizedValue(timeoutInMilliseconds, timeoutUnit))

        onChangeSuccess()

        return {
          isEnabled: _.get(globalAutoCloseConfiguration, 'isEnabled', false),
          savedUnit: timeoutUnit,
          timeoutValue: humanizedTimeoutValue,
          savedTimeout: humanizedTimeoutValue,
          filters: _.get(globalAutoCloseConfiguration, 'filters', {})
        }
      },
    },
  ),
  withProps(props => {
    return {
      hasUnsavedChanges: props.savedTimeout !== props.timeoutValue || props.savedUnit !== props.timeoutUnit,
      minTimeoutValue: Math.ceil(delayTimeUtils.toHumanizedValue(MINUTE, props.timeoutUnit)),
      maxTimeoutValue: Math.floor(delayTimeUtils.toHumanizedValue(WEEK, props.timeoutUnit)),
      exceedsLimitText: `Cannot exceed ${DAYS_IN_WEEK} days`,
    }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (!_.isEqual(prevProps.globalAutoCloseConfiguration, this.props.globalAutoCloseConfiguration)) {
        this.props.handleGlobalAutoCloseConfigurationChange()
      }
    },
  })
)(Component)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/advancedConversationSettings/AutoCloseConfiguration/index.js